import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Modal, Form } from 'react-bootstrap';
import MasterPage from 'components/MasterPage';
import ResalesRequestService from '../../services/resales-request';
import { GroupAddOutlined } from '@material-ui/icons';
import Dialog from 'react-bootstrap-dialog';

import './style.scss';
import Alert from '../../helpers/alert';
import Select from 'react-select';

import { FaSearch } from 'react-icons/fa';

function NewCheckBox({ state, onChange }) {
  const indetSetter = React.useCallback(
    (el) => {
      if (el){
        if(state() === 2) {
          el.indeterminate = true;
        } else {
          el.indeterminate = false;
        }
      }
    },
    [state]
  );
  return (
    <input
      type="checkbox"
      checked={state() === 1}
      ref={indetSetter}
      onClick={onChange}
    />
  );
}

export default function(){
  let dialog;
  const user = JSON.parse(localStorage.getItem('user'));

  const [model, setModel] = useState([]);
  const [modelSelected, setModelSelected] = useState([]);
  const [show, setShow] = useState(false);
  const [load, setLoad] = useState(false);

  const [search, setSearch] = useState('');

  const [test, setTest] = useState(false);
  const [mails, setMails] = useState([]);

  const [users] = useState([
    {id:1,name:'Isa',email:"isa@trend2b.com"},
    {id:2,name:'Robson',email:"robson@trend2b.com"},
    {id:3,name:'Francisco',email:"francisco@trend2b.com"},
    {id:4,name:'Leticia',email:"leticia@trend2b.com"},
    {id:5,name:'David',email:"david.andrade@scansource.com"},
    {id:6,name:'Juliana',email:"juliana.bastasini@scansource.com"},
  ]);

  useEffect(() => {
    ResalesRequestService.getMaster().then(({data})=>{
      setModelSelected(data.data.map(a=>(a.id)));
      setModel(data.data);
    })
  },[]);

  const minWidth = 370;
  const isMobile = window.innerWidth < minWidth;
  const getTamanho = (tamanho) => {
    return window.innerWidth <= tamanho;
  };

  const submit = () => {
    setShow(false);
    setLoad(true);
    const formData = new FormData();
    modelSelected.forEach(a=>{
      formData.append('companies[]',a);
    })
    
    if(test){
      formData.append('teste',true);
      mails.forEach((a,k)=>{
        formData.append(`teste_users[${k}][name]`,a.name);
        formData.append(`teste_users[${k}][email]`,a.email);
      })
    }

    ResalesRequestService.sendMailRevenues(formData).then(data=>{
      Alert.success(`Enviado com sucesso`).then((result) => {
        // if (result.dismiss === Swal.DismissReason.timer) {
        //   history.push('/elite/actions')
        // }
      });
      setLoad(false);
    })
  }

  return (
    <>
      <Modal show={show}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={()=>{
          setShow(false);
        }}
      >
        <Modal.Header closeButton>
          <h5>Empresas</h5>
        </Modal.Header>
        <Modal.Body>
          <Row className="header-select-company">
            <Col xs="auto"><NewCheckBox
            state={()=>{
              if(modelSelected.length == 0){
                return 0;
              }
              if(model.length != modelSelected.length){
                return 2;
              }
              return 1;
            }}
            onChange={(e)=>{
              let value = e.target.checked;
              if(value){
                setModelSelected([...model.map(b=>(b.id))]);
              } else {
                setModelSelected([]);
              }
            }}/></Col>
            <Col>Empresa</Col>
            <Col>
              <Row className="justify-content-end">
                <Col xs="auto">
                  <input className="search-bar" placeholder="Pesquisa" onChange={(e)=>{
                    setSearch(e.target.value);
                  }}></input>
                  <div className="icon-search-company">
                    <FaSearch/>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <div className={"area-select-company"+(test?' teste':'')}>
            {model.filter(a=>{
              return a.name.toUpperCase().indexOf(search.toUpperCase())!=-1;
            }).map((a,k)=>{
              return <Row key={k} className="item-select-company">
                <Col xs="auto">
                <NewCheckBox
                  state={()=>{
                    if(modelSelected.indexOf(a.id) != -1){
                      return 1;
                    }
                    return 0;
                  }}
                  onChange={(e)=>{
                    let value = e.target.checked;
                    if(value){
                      setModelSelected([...modelSelected,a.id]);
                    } else {
                      setModelSelected([...modelSelected.filter(b=>b!=a.id)]);
                    }
                  }}/>  
                </Col>
                <Col>{a.name}</Col>
              </Row>
            })}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Row className="w-100 justify-content-between">
            <Col>
              <Row>
                <Col xs="auto">
                  <Button disabled={test && mails.length == 0} className="mr-1" onClick={()=>{submit()}}>Enviar {test?'Teste':''}</Button>
                </Col>
                <Col xs="auto">
                  <Form.Check 
                    type="switch"
                    id="custom-switch"
                    label="Envio para Teste"
                    checked={test}
                    onChange={(e)=>{
                      setTest(e.target.checked);
                      setMails([]);
                    }}
                  />
                </Col>
              </Row>
            </Col>
            <Col xs="auto">
              <div className="count-selected-company">{modelSelected.length} empresas selecionadas</div>
            </Col>
          </Row>
          {test?(
            <Row className="w-100">
              <Col>
              <Select
                onChange={(e)=>{
                  if(e){
                    setMails(e);
                  } else {
                    setMails([]);
                  }
                }}
                isMulti
                options={users.map(a=>({
                  ...a,value:a.id,label:`${a.name} | ${a.email}`
                }))}
                className="basic-multi-select"
              />
              </Col>
            </Row>
          ):''}
        </Modal.Footer>
      </Modal>
      <Container>
        <Dialog
          ref={(component) => dialog = component}
        />
        <Row className="mt-4">
          <GroupAddOutlined className="icon-title" />
          <h5 className="title-dashboard">Faturamento - Revendas</h5>
        </Row>
        <Row className="">
          <Card.Body className="card-dashboard shadow bg-white rounded m-2 p-5 col-12">
            <Row style={{
              marginTop: '-20px',
              marginBottom: '20px'
            }}>
              <Col>Deseja enviar as informações de faturamento para as revendas?</Col>
            </Row>
            <Button onClick={
              ()=>setShow(true)
            } disabled={load}>Abrir modal de envio</Button>
          </Card.Body>
        </Row>
      </Container>
    </>
  );
};
